import React from 'react';
import { Button, KIND, SIZE } from 'baseui/button';
import { useSetAtom } from 'jotai';
import { commentsAtom } from '../atoms';
import { ModalFooter } from './styled-components';
type Props = {
  onClose: () => void;
  commentIds: number[];
};
export const DeleteComment = ({
  onClose,
  commentIds
}: Props) => {
  const setComments = useSetAtom(commentsAtom);
  const handleDeleteComment = () => {
    setComments(prev => prev.filter((_, index) => !commentIds.includes(index)));
    onClose();
  };
  return <ModalFooter>
      <Button kind={KIND.tertiary} size={SIZE.small} onClick={onClose}>
        Cancel
      </Button>
      <Button kind={KIND.primary} size={SIZE.small} onClick={handleDeleteComment}>
        Delete Comment
      </Button>
    </ModalFooter>;
};